<template>
  <v-container
    ref="container"
    v-scroll="onScroll"
    :class="{'fill-height': !hasTagMenuItems}"
    fluid
  >
    <template v-if="isLoading && !TagMenu[id]">
      <template v-for="(category) in 2">
        <v-row :key="`category-${category}`">
          <v-col cols="12">
            <v-skeleton-loader
              class="py-4"
              max-width="900"
              type="heading"
            />
          </v-col>

          <v-col cols="12">
            <v-container
              fluid
              ma-0
              pa-0
            >
              <v-row>
                <template v-for="(product) in 5">
                  <v-col
                    :key="`category-${category}-product-${product}`"
                    cols="12"
                    lg="4"
                    md="6"
                  >
                    <div>
                      <v-skeleton-loader
                        :types="{'v-skeleton-product-list-item': 'article, avatar'}"
                        class="brand-beige-light"
                        type="v-skeleton-product-list-item"
                      />
                    </div>
                  </v-col>
                </template>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </template>
    </template>

    <template v-else>
      <template v-if="hasTagMenuItems">
        <v-row class="mt-8 mt-md-16">
          <v-col cols="12" />
        </v-row>

        <template v-for="(item, catIdx) in tagMenuItems">
          <v-row
            v-if="item.Items.length > 0 && getStoreById(item.StoreId)"
            :id="`tab-${getTranslatedField(getStoreById(item.StoreId), 'Slug')}`"
            :key="`category-${item.StoreId}-${catIdx}`"
            :dense="$vuetify.breakpoint.xsOnly"
            class="mt-8 mt-md-16"
          >
            <v-col cols="12">
              <div
                class="d-inline-flex"
                style="cursor: pointer;"
                @click="gotoStoreCatalog(item.StoreId)"
              >
                <div class="d-flex align-center">
                  <v-avatar
                    class="mr-3"
                    color="brand-green-dark"
                    size="40"
                    style="border: var(--v-brand-green-dark-base) solid 1px;"
                  >
                    <v-img :src="getStoreById(item.StoreId).Logo" />
                  </v-avatar>

                  <h2 class="brand-text-heading">
                    {{ toLocaleUpperCase(getTranslatedField(getStoreById(item.StoreId))) }}
                  </h2>
                </div>
              </div>

              <v-divider
                class="mt-3"
                style="border-color: var(--v-brand-green-dark-base)"
              />
            </v-col>

            <v-col cols="12">
              <v-container
                fluid
                pa-0
              >
                <v-row :dense="$vuetify.breakpoint.smAndDown">
                  <template v-for="(product, prodIdx) in item.Items">
                    <v-col
                      v-if="product.Active"
                      :key="`category-${item.StoreId}-${catIdx}-product-${product.Id}-${prodIdx}`"
                      cols="12"
                      lg="4"
                      md="6"
                    >
                      <catalog-product-list-item
                        :disabled="AppConfig.StoreClosed.DisableProducts && storeIsClosedById(product.StoreId)"
                        :product="product"
                      />
                    </v-col>
                  </template>

                  <v-col
                    cols="12"
                    lg="4"
                    md="6"
                  >
                    <v-lazy
                      :height="$vuetify.breakpoint.smAndDown ? 130 : 196"
                      :min-height="$vuetify.breakpoint.smAndDown ? 130 : 196"
                      transition="fade-transition"
                    >
                      <v-card
                        class="fill-height brand-card-bg"
                        flat
                        @click="gotoStoreCatalog(item.StoreId)"
                      >
                        <v-container
                          fill-height
                          fluid
                        >
                          <v-row class="justify-center text-center brand-primary--text brand-text-title">
                            <v-col>
                              {{ toLocaleUpperCase($t('Common.Button.SeeMore')) }}
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                    </v-lazy>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </template>
      </template>

      <template v-else>
        <v-row class="fill-height justify-center align-center text-center">
          <v-col cols="12">
            <div class="text-center">
              <div class="mb-6">
                <v-icon
                  color="brand-primary"
                  size="256"
                >
                  mdi-tag-remove
                </v-icon>
              </div>

              <h1 class="brand-text-heading brand-green-dark--text">
                {{ toLocaleUpperCase($t('Tag.Message.NoItems.Title')) }}
              </h1>

              <h4 class="text-body brand-green-dark--text mt-4">
                {{ $t('Tag.Message.NoItems.Subtitle') }}
              </h4>
            </div>
          </v-col>
        </v-row>
      </template>
    </template>

    <v-row>
      <v-col
        class="py-10"
        cols="12"
      />
    </v-row>

    <select-tag-dialog
      :tags="AppTags"
      :visible.sync="tagDialogVisible"
      @tag:selected="onTagSelected"
    />
  </v-container>
</template>

<script>
import TagMixin from '@/theme/default/views/tag/Tag.js'

export default {
  name  : 'Tag',
  mixins: [TagMixin]
}
</script>

<style scoped src="@/theme/default/views/tag/Tag.css"></style>
<style scoped>
</style>
